import IconMap from '../../UI/icon/IconMap';

const defaults = {
	icon: IconMap.circle,
	iconSize: 28,
};
export const transparent = 'rgba(1, 0, 1, 0.5)';
const palette = [
	{
		...defaults,
		label: 'Black',
		value: '#000000',
		iconColor: '#000000',
	},
	{
		...defaults,
		label: 'White',
		value: '#ffffff',
		iconColor: '#ffffff',
	},
	{
		...defaults,
		label: 'Red',
		value: '#ff0000',
		iconColor: '#ff0000',
	},
	{
		...defaults,
		label: 'Purple',
		value: '#8000ff',
		iconColor: '#8000ff',
	},
	{
		...defaults,
		label: 'Blue',
		value: '#0000ff',
		iconColor: '#0000ff',
	},
	{
		...defaults,
		label: 'Cyan',
		value: '#00ffff',
		iconColor: '#00ffff',
	},
	{
		...defaults,
		label: 'Green',
		value: '#00ff00',
		iconColor: '#00ff00',
	},
	{
		...defaults,
		label: 'Yellow',
		value: '#ffff00',
		iconColor: '#ffff00',
	}
];

export default palette;